import Navigation from '@layouts/Navigation/Traqq';
import Hero from './Hero';
import Cards from './Cards';
import Faq from './FAQ';
import FeedbackBanner from './FeedbackBanner';

import React from 'react';

const ScientificCollaborationProgram = () => (
    <>
        <Navigation />
        <Hero />
        <Cards />
        <Faq />
        <FeedbackBanner />
    </>
);

export default ScientificCollaborationProgram;
